import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import './TextInput.css';

export default class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: (this.props.existingContent !== undefined && this.props.existingContent !== null) ? this.props.existingContent : ""
    };
  }

  componentWillReceiveProps(newProps) {
    if ('existingContent' in newProps && newProps.existingContent !== undefined && newProps.existingContent !== this.state.value) {
      this.setState({ value: newProps.existingContent });
    }

    if (this.props.selectedOption !== null) {
      const selectedOption = newProps.selectedOption;

      if (selectedOption !== this.props.selectedOption) {
        if (selectedOption !== '')
          this.setState({ value: selectedOption })
      }
    }
  }


  focusAtSetCaret(caretPos) {
    let elem = this[`${this.props.id}__text-input`];
    if (elem != null) {
      elem.focus();
      if (elem.createTextRange) {
        let range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      }
      else if (elem.setSelectionRange) {
        elem.setSelectionRange(caretPos, caretPos);
      }
    }
  }

  hasFocus() {
    return this[`${this.props.id}__text-input`] === document.activeElement;
  }

  selectionStart() {
    return this[`${this.props.id}__text-input`].selectionStart;
  }

  getValue = () => {
    let value = this.state.value;

    if (this.props.trim) {
      value = value.trim();
      this.setState({ value });
    }

    if (this.props.required && value === "") {
      throw new InputError(this.props.label + " is Required", value);
    }

    // only validate the regex if the field is populated
    if (this.props.patternMatch && value !== "") {
      if (!value.match(this.props.patternMatch)) {
        let patternError = (this.props.patternMatchError) ?
          this.props.patternMatchError :
          this.props.label + " is Invalid";

        throw new InputError(patternError, value);
      }
    }

    return value;
  }

  handleChange = (e) => {
    e.persist();

    let callOnChange = () => {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
    }

    this.setState((state, props) => {
      if (props.maxLength) {
        if (typeof e.target.value === 'number') {
          return {
            value: parseInt(e.target.value.toString().slice(0, props.maxLength), 10)
          }
        }
        else {
          return {
            value: e.target.value.slice(0, props.maxLength)
          }
        }
      }
      else {
        return { value: e.target.value }
      }
    }, callOnChange);
  }

  render() {

    let label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;

    let inputHelperText = this.props.helperText;
    let inputInfoText = this.props.infoText;

    if (this.props.type === "date" && !(/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor))) {
      inputHelperText = "(Format: YYYY-MM-DD)";
    }

    let helperText = inputHelperText ?
      <span className="helper-text">
        {inputHelperText}
      </span> :
      null;
    
    let infoText = inputInfoText ?
      <span className="info-text">
        {inputInfoText}
      </span> :
      null;

    let errorMessage = (this.props.errorMessage) ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    let existingContent = (this.props.type !== "password" || !this.props.existingContent) ?
      this.props.existingContent :
      this.props.existingContent.replace(/.*/, '**********');

    let requiredFieldIndicator = (this.props.required) ?
      <abbr title="This field is required">*</abbr> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let inputDisplay = (this.props.isEditable) ?
      <span>
        {requiredFieldIndicator}{label}
        {infoText}
        <input
          autoComplete={(this.props.autoComplete) ? null : "off"}
          className={this.props.className}
          disabled={this.props.disabled}
          id={this.props.id}
          onChange={(e) => this.handleChange(e)}
          placeholder={this.props.placeholderText}
          required={this.props.required}
          type={this.props.type}
          value={this.state.value}
          max={this.props.numberMax}
          min={this.props.numberMin}
          step={this.props.numberStep}
          minLength={this.props.minLength}
          maxLength={this.props.maxLength}
          ref={instance => { this[`${this.props.id}__text-input`] = instance; }}
        />
        {helperText}
        {errorMessage}
      </span> :
      <span>
        {label}
        <div className="read-only">
          {existingContent}
        </div>
      </span>;

    return (
      <div className={verticalSpacingClass}>
        {inputDisplay}
      </div>
    );
  }
}

TextInput.defaultProps = {
  autoComplete: true,
  isEditable: true,
  trim: false,
  type: "text"
};

TextInput.propTypes = {
  autoComplete: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  existingContent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.string,
  minLength: PropTypes.string,
  numberMax: PropTypes.string,
  numberMin: PropTypes.string,
  numberStep: PropTypes.string,
  onChange: PropTypes.func,
  patternMatch: PropTypes.instanceOf(RegExp),
  patternMatchError: PropTypes.string,
  placeholderText: PropTypes.string,
  required: PropTypes.bool,
  selectedOption: PropTypes.string,
  trim: PropTypes.bool,
  type: PropTypes.string,
  verticalSpacing: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/text-input/TextInput.js